import { render, staticRenderFns } from "./TakeOrder.vue?vue&type=template&id=5351d47a&scoped=true&"
import script from "./TakeOrder.vue?vue&type=script&lang=js&"
export * from "./TakeOrder.vue?vue&type=script&lang=js&"
import style0 from "./TakeOrder.vue?vue&type=style&index=0&id=5351d47a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5351d47a",
  null
  
)

export default component.exports